<div class="block--bg-wrapper check-status__card-number">
    <div class="purchase-history-tickets">
        <span class="purchase-history-tickets__description" *ngIf="showText">{{
            'CARD_STATUS_SELECT_PERIOD_HISTORY_DESCRIPTION' | translate
        }}</span>
        <h2 class="purchase-history-tickets__period" *ngIf="showTitle">
            {{ 'CARD_STATUS_SELECT_PERIOD_HISTORY' | translate }}
        </h2>

        <div class="purchase-history-tickets__starting-point">
            <div class="date-selector">
                <ridango-datepicker
                    [label]="startLabel"
                    [lang]="locale"
                    [date]="startDate"
                    [maxDate]="maxStartDate"
                    [minDate]="minStartDate"
                    [yearsControl]="false"
                    [dateFormat]="dateFormat"
                    [ariaLabel]="startAriaLabel"
                    [useMaterialIcon]="useMaterialIcon"
                    (dateUpdated)="startDateUpdated($event)">
                </ridango-datepicker>
            </div>
        </div>

        <div class="purchase-history-tickets__ending-point">
            <div class="date-selector">
                <ridango-datepicker
                    [label]="endLabel"
                    [lang]="locale"
                    [date]="endDate"
                    [maxDate]="maxEndDate"
                    [minDate]="minEndDate"
                    [yearsControl]="false"
                    [disabled]="automaticEnd"
                    [dateFormat]="dateFormat"
                    [ariaLabel]="endAriaLabel"
                    [useMaterialIcon]="useMaterialIcon"
                    (dateUpdated)="endDateUpdated($event)">
                </ridango-datepicker>
            </div>
        </div>

        <div class="purchase-history-tickets__selection">
            <button class="btn btn--big btn--primary" (click)="commitPeriod()">
                {{ 'BTN_SELECT' | translate }}
            </button>
        </div>

        <div class="purchase-history-tickets__right-item printer" *ngIf="showPrint">
            <button
                class="btn btn--big btn--maximal img-icon bg-[#E6E6E6] text-primary-text dark:bg-contrast-yellow dark:text-contrast-black"
                [attr.aria-label]="'PRINT_PURCHASE_HISTORY' | translate"
                (click)="triggerPrint()"
                type="button">
                <img
                    class="dark:filter-black"
                    src="assets/print.svg"
                    alt="{{ 'PRINT_PURCHASE_HISTORY' | translate }}"
                    role="presentation"
                    aria-hidden="true" />
                <span>{{ 'PRINT_PURCHASE_HISTORY' | translate }}</span>
            </button>
        </div>
    </div>
</div>
